import { clearFullCaches } from '@packages/common/utils/clearFullCaches';
import { type AppHostConfig, appConfig } from '@packages/config/app/app.config';
import { appHostMfs } from '@packages/config/appHosts';
import { getCurrentStand } from '@packages/config/utils/getCurrentStand';
import { isHost } from '@packages/config/utils/isHost';
import { delay } from '@packages/utils/delay';
import type { ModuleFederationRuntimePlugin } from '@module-federation/enhanced/runtime';
import type { AppsServicesKeys } from '@packages/config/app/appsServices';
import type { AppEnvs } from '@packages/config/app/types';
import type { MFNamesKeys } from '@packages/config/MFNames';

export default function (): ModuleFederationRuntimePlugin {
	let remotesUpdated = false;
	return {
		name: 'runtimeMFPlugin',
		beforeInit(args) {
			const mfName = args.origin.name as MFNamesKeys;
			beforeInit(mfName);
			return args;
		},
		beforeRequest(args) {
			if (!remotesUpdated && args.options.remotes.length) {
				for (const remote of args.options.remotes) {
					if ('entry' in remote) {
						remote.entry = window.getMfManifestUrl(
							remote.name as MFNamesKeys,
						);
					}
				}

				remotesUpdated = true;
			}

			return args;
		},

		errorLoadRemote(args) {
			if (args.from === 'runtime') {
				// @ts-ignore
				if (args.error?.message === 'Not Internet connection') {
					document.documentElement.setAttribute(
						'app-not-internet-connection',
						String(true),
					);
				} else {
					const url = new URL(window.location.href);
					const retry =
						Number(url.searchParams.get('retry') || 0) + 1;
					url.searchParams.set('retry', String(retry));
					document.documentElement.setAttribute(
						'app-mf-error',
						String(true),
					);
					delay(retry * 1000)
						.then(() => clearFullCaches())
						.then(() => window.location.replace(url));
				}
			}
		},
	};
}
export function beforeInit(mfName: MFNamesKeys) {
	if (isHost(mfName)) {
		const stand = getCurrentStand();

		const appHostConfig: AppHostConfig = appHostMfs[mfName]
			? appConfig[mfName]
			: appConfig.efr;
		window.getMfLink = (mfLink: MFNamesKeys) =>
			appHostConfig[stand].getMfLink(mfLink);
		window.getMfManifestUrl = (mfLink: MFNamesKeys) =>
			`${appHostConfig[stand].getMfLink(mfLink)}/mf-manifest.json`;
		window.getServiceWorkerInfo = () =>
			appHostConfig[stand].getServiceWorkerInfo();
		window.getApiService = (serviceName: AppsServicesKeys) =>
			appHostConfig[stand].getApiService(serviceName);
		window.getAppEnv = (envName: AppEnvs) =>
			appHostConfig[stand].getAppEnv(envName);

		window.appName = appHostConfig[stand].appName;
		window.envs = appHostConfig[stand].appEnvs;
		window.rootPath = appHostConfig[stand].rootPath;
		window.baseUrl = appHostConfig[stand].baseUrl;
		window.taskName = appHostConfig[stand].taskName;
		window.getWebStaticFilePath = appHostConfig[stand].getWebStaticFilePath;
	}
}
